import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableData from "../TableData";
import PartData from "../PartData";
import PropTypes from "prop-types";
import "./style.css";
import { select } from "../../../../actions/parts";
import { hashToSelectedValues } from "../../../../utilities/hash";
import localization from "../../../../data/config";
import MediaQuery from "react-responsive";
import breakpoints from "../../../../constants/breakpoints";

/**
 * @name Row
 * @function
 * @description Displays Each Row for the Table
 * @returns {JSX}
 * @param {*} props
 */
const Row = (props) => {
  const [isRowChecked, setIsRowChecked] = useState(false);
  const dispatch = useDispatch();
  const { parameters, selected, parts, allData } = useSelector((state) => ({
    parameters: state.filters.parameters,
    selected: state.parts.selected,
    parts: state.parts.data,
    allData: state.parts.allData
  }));

  //function to handle the checkbox selection state.
  const handleselectedFunction = () => {
    setIsRowChecked(!isRowChecked);
    dispatch(select(props.id, parts));   
  };

  //useEffect hook to set the checked state of all the rows when props.selectAll(SelectAll checkbox) changes.
  useEffect(() => {
    setIsRowChecked(props.selectAll);
  }, [props.selectAll]);

  //useEffect to handle the check and uncheck state of Select all checkbox if any parts checkbox state is changed.
  useEffect(()=>{
    const allDataLength = allData.map((part)=>part.id).length;
    if(allDataLength === selected.length) props.setSelectAll(true);
    else props.setSelectAll(false);
  }, [selected]);

  useEffect(() => {
    let newSelected = selected.includes(props.id);
    if (newSelected !== isRowChecked) setIsRowChecked(newSelected);
  });

  let selectedRows = hashToSelectedValues();
  useEffect(() => {
    setIsRowChecked(selectedRows.includes(props.id));
  }, [props.id, selectedRows]);

  return (
    <tr
      className={`table-row ${
        isRowChecked || (selected.length > 0 && selected.includes(props.id))
          ? "checked"
          : ""
      }`}
      data-controller={props.id}
    >
      <MediaQuery minDeviceWidth={breakpoints.tablet.max + 1}>
        <td
        aria-label={`${localization.selectLabel} ${props["0"].displayValue}`}
          className={`row__checkbox ${
            isRowChecked || (selected.length > 0 && selected.includes(props.id))
              ? "selected checked__border"
              : ""
          }`}
        >
          <input
            type="checkbox"
            aria-label={`${localization.selectLabel} ${props["0"].displayValue}`}
            className="checkbox checkbox-global__input"
            onChange={handleselectedFunction}
            checked={selected.includes(props.id) || isRowChecked}
          />
        </td>
      </MediaQuery>
      <PartData
        evalBoardUrl={props["0"].evalBoardUrl}
        displayValue={props["0"].displayValue}
        DataSheets={props["0"].DataSheets}
        hasDataSheet={Object.hasOwn(props["0"], 'hasDataSheet') ? props["0"].hasDataSheet : true}
        generic={props["0"].generic}
        id={props.id}
        style={
          isRowChecked || (selected.length > 0 && selected.includes(props.id))
            ? "selected"
            : ""
        }
        className={props.className}
      />
      {parameters.length > 0
        ? parameters.map((parameter, index) => (
            <TableData
              generic={props["0"].generic}
              evalBoardUrl={props["0"].evalBoardUrl}
              format={parameter.format}
              name={parameter.name}
              key={`parameter-${index}`}
              parameter={parameter.id}
              {...props[parameter.id]}
            />
          ))
        : null}
    </tr>
  );
};

Row.defaultProps = {
  minimized: false,
};

Row.propTypes = {
  id: PropTypes.string.isRequired,
  minimized: PropTypes.bool,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      format: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  mobile: PropTypes.bool,
  setSelectAll: PropTypes.func,
};

export default Row;
